import React, { useState } from "react";

function Sidebar({ folders, onSelectFolder, loading, currentPath }) {
  const [expandedNodes, setExpandedNodes] = useState({});

  // Toggle expansion of a folder node
  const toggleNode = (folderName) => {
    setExpandedNodes((prev) => ({
      ...prev,
      [folderName]: !prev[folderName],
    }));
  };

  const renderFolders = (folderList, parentPath = "\\") =>
    folderList.map((folder, index) => {
      const fullPath =
        parentPath === "\\"
          ? `\\${folder.label}`
          : `${parentPath}\\${folder.label}`;

      const isSelected = currentPath === fullPath;

      return (
        <li key={index}>
          <div
            onClick={() => {
              toggleNode(folder.label);
              // Only navigate if leaf node (preserving original behavior)
              // Or should we allow navigation to any folder?
              // Original code: if (!hasChildren || hasChildren.length === 0)
              if (!folder.children || folder.children.length === 0) {
                onSelectFolder(fullPath);
              }
            }}
            style={{
              cursor: folder.children ? "pointer" : "default",
              textDecoration: isSelected ? "underline" : "none",
              fontWeight: isSelected ? "bold" : "normal",
              color: isSelected ? "#84171A" : "inherit",
            }}
          >
            <i
              className={`fa-regular fa-folder me-2 ${
                expandedNodes[folder.label] || isSelected
                  ? "fa-folder"
                  : "fa-folder"
              }`}
            ></i>
            {folder.label}
          </div>
          {folder.children && expandedNodes[folder.label] && (
            <ul style={{ paddingLeft: "20px" }}>
              {renderFolders(folder.children, fullPath)}{" "}
            </ul>
          )}
        </li>
      );
    });

  return (
    <div className="sidebar">
      <h5 className="mb-2">Folders</h5>
      {loading && (
        <div className="file-manager-loader-overlay">
          <div className="fa fa-spinner fs-7"></div>
        </div>
      )}
      <ul>{renderFolders(folders)}</ul> {}
    </div>
  );
}

export default Sidebar;
